<div class="row">
    <div class="col-12">
        <swiper
            [config]="standardConfig"
            (swiper)="onWhySwiper($event)"
            (slideChange)="onWhySlideChange()"
            class="w-100">
            <ng-template swiperSlide class="testimonial-wrapper w-100 px-2" *ngFor="let quote of quotes">

                <div class="container-fluid p-0">
                    <div class="row">
                        <div class="col-12 col-lg-9 offset-lg-1 col-xl-7 offset-xl-2">
                            <div class="testimonial-block w-100 h-100 position-relative">
                                <div class="rounded-circle w-175px h-175px testimonial-image mx-auto mx-lg-0"
                                     [style.background]="'url('+quote.image+')'" [title]="quote.image_alt ? quote.image_alt : quote.title">
                                    <div style="position: relative; width: 100%; height:100%;">
                                        <img loading="lazy" src="assets/img/icons/icn-play.svg" *ngIf="quote.video"  class="cursor-pointer"
                                             style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" width="50" />
                                    </div>
                                </div>
                                <div class="testimonial-block-inner bg-white rounded h-lg-100 shadow d-flex align-items-center mb-5">
                                    <div class="testimonial-block-content">
                                        <p class="font-size-22 lh-sm font-italic" [innerHTML]="quote.quote | safeHtml"></p>
                                        <p class="font-size-16 font-weight-normal mb-0">{{ quote.author }}</p>
                                        <p class="font-size-16 text-muted">{{ quote.title }}</p>

                                        <img loading="lazy" *ngIf="quote.logo" [src]="quote.logo" [alt]="quote.logo_alt ? quote.logo_alt : quote.title" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </ng-template>

            <button class="custom-prev rounded-circle" slot="container-start">
                <mat-icon aria-hidden="false" aria-label="Previous">west</mat-icon>
            </button>
            <div class="custom-next rounded-circle" slot="container-end">
                <mat-icon aria-hidden="false" aria-label="Next">east</mat-icon>
            </div>

        </swiper>

        <!--<ng-container *ngIf="quotes?.length > 1">
            <div class="swiper-buttons text-right d-none d-sm-none d-md-block">
                <button class="btn btn-white shadow-xs rounded-circle btn-previous" 
                    [class.disabled]="isBeginWhy"
                    (click)="gotoWhyPrevious()">
                    <mat-icon aria-hidden="false" aria-label="Previous">west</mat-icon>
                </button>
                <button class="btn btn-white shadow-xs rounded-circle btn-next" 
                    [class.disabled]="isEndWhy"
                    (click)="gotoWhyNext()">
                    <mat-icon aria-hidden="false" aria-label="Next">east</mat-icon>
                </button>
            </div>
        </ng-container>-->
    </div>
</div>